import { commonOptions } from '@/config'
import { getCommonOptionLabel } from '@/utils'

export interface DeviceAffiliatedPart {
  type: string
  sn: string
  model: string
  supplier: string
  status: string
}

export function normalizeAffiliatedParts(response: any, fallback: DeviceAffiliatedPart[] = []) {
  const list = response?.result?.affiliatedList || response?.affiliatedList || []

  if (!Array.isArray(list) || !list.length) return fallback

  return list.map((item: any) => ({
    type: item?.deviceType || '',
    typeName: getCommonOptionLabel(commonOptions.tdlDeviceType, item?.deviceType) || item?.deviceType || '',
    sn: item?.snCode || '',
    model: item?.modelCode || '',
    supplier: item?.manufacturerName || '',
    status: item?.deviceStatus || '',
    statusName: getCommonOptionLabel(commonOptions.tdlDeviceStatus, item?.deviceStatus || '')
  }))
}
